var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuidv4 } from 'uuid';
import GetFileUrlApi from '~/api/get-file-url';
const downloadDocumentsAction = (documents, downloadType, showToast) => __awaiter(void 0, void 0, void 0, function* () {
    const preppedDocs = [];
    for (const doc of documents) {
        let docName = doc.name;
        const docNameSplit = docName.split('.');
        docNameSplit.pop();
        docName = docNameSplit.join('.');
        docName += downloadType === 'docx' ? '.docx' : '.pdf';
        const fileTransferInfo = yield GetFileUrlApi.getUrlById(doc.id, downloadType === 'docx');
        let fileTransferUrl = fileTransferInfo.fileTransferUrl;
        fileTransferUrl = fileTransferUrl.replace('download-file', 'download-file-direct');
        fileTransferUrl += `&file_name=${docName}`;
        preppedDocs.push({
            id: doc.id,
            name: docName,
            fileTransferUrl,
        });
    }
    const downloadInterval = setInterval(() => {
        if (preppedDocs.length === 0) {
            clearInterval(downloadInterval);
            return;
        }
        const preppedDoc = preppedDocs.pop();
        if (!preppedDoc) {
            clearInterval(downloadInterval);
            return;
        }
        const anchorElement = document.createElement('a');
        anchorElement.style.display = 'none';
        document.body.appendChild(anchorElement);
        anchorElement.setAttribute('href', preppedDoc.fileTransferUrl);
        anchorElement.setAttribute('download', preppedDoc.name);
        anchorElement.click();
        document.body.removeChild(anchorElement);
    }, 500);
    showToast({
        id: uuidv4(),
        description: `Documents Downloaded Successfully (${documents.length})`,
    });
});
export default downloadDocumentsAction;
